export const ADMIN_URL_PREFIX = '/admin'
